import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';

export const useAccountBottomBarStyles = createStyles(({ token }) => ({
  accountBottomBar: {
    height: 25,
    color: ThemeColors.COLOR_GREY3,
    fontWeight: 500,
    fontSize: ThemeFont.FONT_SIZE_XS,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: ThemeSpaces.SPACE_XS,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      display: 'none',
    },

    '.DropdownMenu-Label, .Popup-Label': {
      '.fa-caret-down, .fa-caret-up': {
        fontSize: token.fontSizeLG,
      },
    },
  },
}));
